import { render, staticRenderFns } from "./ReleaseDetailEdit.vue?vue&type=template&id=4db79fd3&"
import script from "./ReleaseDetailEdit.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports